module.exports = __webpack_public_path__ + "static/media/Gravity-Bold.81cc224b.otf";